import GalleryImage from "./GalleryImage";
import useFetchImages from "@hooks/images/useFetchImages";
import { useContext } from "react";
import { AppContext } from "@components/features/appContext/AppContext";
import { ImageType } from "next-lib";

function Gallery() {
  const { language } = useContext(AppContext);
  const { images } = useFetchImages(language);

  return (
    <>
      <div className="mt-12 flex items-center justify-center">
        <div className="gallery md:grid-cols-4 grid-cols-2">
          {images?.map((image: ImageType, index: number) => (
            <GalleryImage key={index} image={image} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Gallery;
